import React from 'react';
import { render } from 'react-dom';

import { createRegisterApp } from './registers'

import { initialMutableFilteringState } from "./registers/core/reducers/filtering";
import { initialMutableSearchingState } from "./registers/core/reducers/searching";

import {
    getActiveFiltersFromQuerystring,
    getSearchFromQuerystring,
    getSortByFromQuerystring,
    getSortDescendingFromQuerystring,
} from "./registers/utils/url.parse";
import onPageReady from "./utils/onPageReady";
import { initialMutableSortingState } from "./registers/core/reducers/sorting";


function mountApp() {

    const mountNode = document.getElementById('mountnode');
    if (mountNode) {

        const preloadedState = {
            mutableFiltering: {
                ...initialMutableFilteringState,  // for DRY reasons we use the elsewhere defined initial filtering state
                activeFilters: getActiveFiltersFromQuerystring(location.search)
            },
            mutableSearching: {
                ...initialMutableSearchingState,  // for DRY reasons we use the elsewhere defined initial search state
                searchQuery: getSearchFromQuerystring(location.search),
            },
            mutableSorting: {
                ...initialMutableSortingState,  // for DRY reasons we use the elsewhere defined initial search state
                sortBy: getSortByFromQuerystring(location.search),
                descending: getSortDescendingFromQuerystring(location.search)
            },
        };

        render( createRegisterApp(preloadedState), mountNode );
    }
}

onPageReady(() => mountApp());
